const defaultColumnWidth = 1;
const nameColumnWidth = 10;
const lastColumnWidth = 2; 
// Calculated width percentage with previous column width values
const totalSegmentWidth = (3* defaultColumnWidth + lastColumnWidth) * 6.25;


export {
    defaultColumnWidth,
    nameColumnWidth,
    lastColumnWidth,
    totalSegmentWidth,
}



// WEBPACK FOOTER //
// ./src/components/Pro/DevisFactures/EditionDevisFactures/DevisComp/Constants.js